export default __webpack_public_path__ + "static/media/add-to-board-pin.c996fa7a.svg";